import { FC } from "react";
import { FieldValues, UseFormRegister } from "react-hook-form";

import { Field } from "@types";

import { Label } from "./Label";
import s from "./InputField.module.scss";

interface Props extends Field {
  register: UseFormRegister<FieldValues>;
}

export const InputField: FC<Props> = ({
  label,
  id,
  name,
  type,
  register,
  placeholder,
  required = false,
  disabled = false,
}) => (
  <>
    <Label id={id} label={label} required={required} />
    <input
      id={id}
      type={type}
      className={s.Input}
      placeholder={placeholder}
      required={required}
      disabled={disabled}
      {...register(name, { required })}
    />
  </>
);
